import type {OptionType} from "../components/Select";

export function convertOptionsToMap<
    Value extends OptionType<string>["value"],
    Option extends OptionType<Value>
>(options: Option[]): Record<Value, string> {
    return options.reduce<Record<Value, string>>((result, option) => {
        result[option.value] = option.label;
        return result;
    }, {} as Record<Value, string>);
}
